import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

type AdminStatCardProps = {
  label: string;
  value: string;
  meta: string;
  metaTone?: "positive" | "muted";
  icon: ReactNode;
};

export function AdminStatCard({
  label,
  value,
  meta,
  metaTone = "muted",
  icon,
}: AdminStatCardProps) {
  return (
    <article className="flex min-w-0 flex-1 flex-col gap-4 rounded-xl border border-white/5 bg-[#132136] p-5">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.5px] text-[#9194a1]">
          {label}
        </p>
        <span className="flex size-4 shrink-0 items-center justify-center">
          {icon}
        </span>
      </div>
      <div className="flex items-baseline gap-2">
        <p className="text-2xl font-bold text-white">{value}</p>
        <p
          className={cn(
            "text-xs font-medium",
            metaTone === "positive" ? "text-[#22c55e]" : "text-[#9194a1]",
          )}
        >
          {meta}
        </p>
      </div>
    </article>
  );
}
